import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import ResourceRow from './components/ResourceRow';
import { DRAGS, REDIPS } from './components/drag';
import KenDialog from '../../../../global_components/KenDialogBox';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { RiCheckFill } from 'react-icons/ri';
import KenPopover from '../../../../Components/KenPopOver';

export const IsDraggingContext = React.createContext(false);
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },

  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  popOverTitle: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#ffffff',
    backgroundColor: '#092682',
    fontSize: '14px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
  },
  fitlerButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  popOverData: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#092682',
    fontSize: '12px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
  noDataFound: {
    fontWeight: '600',
    fontSize: '14px',
  },
  filterButton: {
    marginRight: '10px',
  },
}));
const CustomTimeline = ({
  calendarDay,
  calendarEvents,
  calendarResources,
  setAllEventData,
  toogleButton,
}) => {
  console.log('calendarEvents', calendarEvents);
  const classes = useStyles();

  const [isDragging, setIsDragging] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const [loading, setLoading] = useState(false);
  const [today, setToday] = useState();
  const [resources, setResources] = useState([]);
  const [events, setEvents] = useState([]);

  const [draggingTaskId, setDraggingTaskId] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const open = Boolean(anchorEl);

  const ids = open ? 'simple-popover' : undefined;

  // Drag and Drop
  const [obj, setObj] = useState(null);
  const [prevoiusInfo, setPrevoiusInfo] = useState(null);
  const [currentInfo, setCurrentInfo] = useState(null);
  const [sourceInfo, setSourceInfo] = useState(null);
  const [targetInfo, setTargetInfo] = useState(null);
  const [isConfirm, setConfirm] = useState(true);
  const [redipsItem, setRedipsItem] = useState('');

  function handleDialog() {
    setConfirmDialog((prevState) => !prevState);
  }

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handlePopoverOpen = (event) => {
    console.log('currentTarget', event.currentTarget);
    setAnchorEl(event.currentTarget);
  };

  // const dragFunc = JSON.parse(localStorage.getItem('redips'));
  // useEffect(() => {
  //   setRedipsItem(dragFunc);
  // }, []);
  useEffect(() => {
    if (typeof REDIPS.drag === 'function') {
      setObj(REDIPS.drag());

      REDIPS.drag = REDIPS.drag();
    }
    // return () => {
    //   setObj(DRAGS.drag());
    //   REDIPS.drag = DRAGS.drag();
    // };
    else {
      // window.location.reload(false);
      setObj(DRAGS.drag());
      REDIPS.drag = DRAGS.drag();
    }
  }, [toogleButton, calendarEvents, resources]);

  useEffect(() => {
    if (obj && resources) {
      console.log('coming');
      // initialization
      REDIPS.drag?.init();
      // set hover color
      //      REDIPS.drag.hover.colorTd =  '#E7C7B2';

      REDIPS.drag.hover_color = '#E7C7B2';

      // class
      REDIPS.drag.only.div.a1 = 'last';
      console.log('options', REDIPS.drag.only.div);
      // set drop option to 'switching'
      REDIPS.drag.drop_option = 'single';
      // display action in the message line (list of all event handlers can be found at the drag.js bottom)
      REDIPS.drag.myhandler_clicked = function (evt) {
        console.log('myhandler_clicked', evt);

        // document.getElementById('message').innerHTML = 'Element is clicked';
      };
      REDIPS.drag.myhandler_moved = function () {
        console.log('myhandler_moved');
        // document.getElementById('message').innerHTML = 'Element is moved';
      };
      REDIPS.drag.myhandler_notmoved = function () {
        console.log('myhandler_notmoved');

        // document.getElementById('message').innerHTML = 'Element is not moved';
      };
      REDIPS.drag.myhandler_dropped = function () {
        const { previous_cell, current_cell, source_cell, target_cell } =
          REDIPS.drag;
        setConfirmDialog(true);

        console.log(REDIPS.drag.obj.attributes['data-event-hours']?.value);

        const dataHours = parseInt(target_cell.attributes['data-hour'].value);
        const evtHours = parseInt(
          REDIPS.drag.obj.attributes['data-event-hours']?.value
        );
        console.log('dh', dataHours);
        console.log('eH', evtHours);
        console.log('evtHours', dataHours + evtHours);

        if (dataHours + evtHours > 19) {
          REDIPS.drag.move_object(target_cell, source_cell);
          return;
        }

        setPrevoiusInfo({
          resourceId: current_cell.attributes['data-resourceid'].value,
          eventStartHour: parseInt(current_cell.attributes['data-hour'].value),
        });
        setCurrentInfo({
          resourceId: previous_cell.attributes['data-resourceid'].value,
          eventStartHour: parseInt(previous_cell.attributes['data-hour'].value),
        });
        setSourceInfo({
          resourceId: source_cell.attributes['data-resourceid'].value,
          eventStartHour: parseInt(source_cell.attributes['data-hour'].value),
        });
        setTargetInfo({
          resourceId: target_cell.attributes['data-resourceid'].value,
          eventStartHour: parseInt(target_cell.attributes['data-hour'].value),
          eventId: target_cell?.children[0]?.attributes['data-evtid']?.value,
        });

        // document.getElementById('message').innerHTML = 'Element is dropped';
      };
    }
  }, [obj, resources, toogleButton]);

  useEffect(() => {
    if (REDIPS.drag) {
      console.log('sourceInfo', sourceInfo);
      const { previous_cell, current_cell, source_cell, target_cell } =
        REDIPS.drag;
      console.log('source_cell', source_cell);
      console.log('current_cell', current_cell);

      if (source_cell !== current_cell) {
        if (isConfirm === false) {
          REDIPS.drag.move_object(target_cell, source_cell);
          setConfirmDialog(false);
          setConfirm(true);
        } else {
          setConfirmDialog(false);
        }
      }
    }
  }, [obj, resources, isConfirm]);

  useEffect(() => {
    if (sourceInfo && targetInfo) {
      setAllEventData((prev) => {
        return prev.map((evt) => {
          const evtStart = evt.start;
          const evtEnd = evt.end;

          if (evt.id === parseInt(targetInfo.eventId)) {
            let st = moment(evtStart);
            let ed = moment(evtEnd);
            st.set({ hour: parseInt(targetInfo.eventStartHour) });
            ed.set({ hour: parseInt(targetInfo.eventStartHour) + evt.hours });
            let updatedStartDate = st.format('YYYY-MM-DD HH:mm:ss');
            let updatedEndDate = ed.format('YYYY-MM-DD HH:mm:ss');
            return {
              ...evt,
              start: updatedStartDate,
              end: updatedEndDate,
              resourceId: targetInfo.resourceId,
            };
          } else {
            return { ...evt };
          }
        });
      });
    }
  }, [sourceInfo, targetInfo, setAllEventData, toogleButton]);

  useEffect(() => {
    setLoading(true);

    setToday(calendarDay);
    setResources(calendarResources);
    setEvents(calendarEvents);

    setLoading(false);
  }, [calendarDay, calendarResources, calendarEvents, resources]);

  const onDragStart = (start) => {
    console.log('Drag started!!!!');
    // const id = start.draggableId;
    // console.log(id);
    // const selected = this.state.selectedTaskIds.find((taskId) => taskId === id);

    // // if dragging an item that is not selected - unselect all items
    // if (!selected) {
    //   this.unselectAll();
    // }
    // setDraggingTaskId(start.draggableId);
  };

  const onDragEnd = (result) => {
    console.log('Drag ended!!!!');
    // setIsDragging(false);

    // // dropped outside the list
    // if (
    //   !result.destination ||
    //   result.destination.index === result.source.index
    // ) {
    //   return;
    // }

    // // no movement
    // if (result.destination.index === result.source.index) {
    //   return;
    // }

    // TODO set updated list to main list/call APIs
    // const quotes = reorder(setConfirm
    // this.setState({
    //   quotes,
    // });
  };

  const toggleSelection = () => {};
  const toggleSelectionInGroup = () => {};
  const multiSelectTo = () => {};

  return loading ? (
    <div>Loading...</div>
  ) : (
    // <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
    <div id="drag">
      <table className="react-calendar " id="table1">
        <thead className="rt-header">
          <tr>
            <th rowSpan={3} width={300} className="mark">
              Facility
            </th>
            <th
              colSpan={12}
              className="mark"
              style={{ maxWidth: '480px', width: '480px' }}
            >{`Wk ${moment(today).week()}`}</th>
          </tr>
          <tr>
            <th
              colSpan={12}
              className="mark"
              style={{ maxWidth: '480px', width: '480px' }}
            >
              {moment(today).format('ddd DD')}
            </th>
          </tr>
          <tr style={{ maxWidth: '480px', width: '480px' }}>
            <th
              style={{ maxWidth: '40px', fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              7 AM
            </th>
            <th
              style={{ maxWidth: 40, fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              8 AM
            </th>
            <th
              style={{ maxWidth: 40, fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              9 AM
            </th>
            <th
              style={{ maxWidth: 40, fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              10 AM
            </th>
            <th
              style={{ maxWidth: 40, fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              11 AM
            </th>
            <th
              style={{ maxWidth: 40, fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              12 PM
            </th>
            <th
              style={{ maxWidth: 40, fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              1 PM
            </th>
            <th
              style={{ maxWidth: 40, fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              2 PM
            </th>
            <th
              style={{ maxWidth: 40, fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              3 PM
            </th>
            <th
              style={{ maxWidth: 40, fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              4 PM
            </th>
            <th
              style={{ maxWidth: 40, fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              5 PM
            </th>
            <th
              style={{ maxWidth: 40, fontSize: '11px', padding: '8px 0' }}
              className="mark"
            >
              6 PM
            </th>
          </tr>
        </thead>
        <tbody className="rt-body">
          {resources.map((resource) => (
            <ResourceRow
              events={calendarEvents}
              key={resource.id}
              resourceItem={resource}
              draggingTaskId={draggingTaskId}
              toggleSelection={toggleSelection}
              toggleSelectionInGroup={toggleSelectionInGroup}
              multiSelectTo={multiSelectTo}
              handlePopoverOpen={handlePopoverOpen}
            />
          ))}
        </tbody>
        {/* <Droppable droppableId="table">
          {(droppableProvided) => (
            <tbody {...droppableProvided.droppableProps} className="rt-body">
              {resources.map((resource) => (
                <ResourceRow
                  key={resource.id}
                  resourceItem={resource}
                  events={events}
                />
              ))}
            </tbody>
          )}
        </Droppable> */}
      </table>

      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Confirmation
          </Typography>
        }
        open={confirmDialog}
        icon={<RiCheckFill />}
        handleClose={() => setConfirmDialog(false)}
        negativeButtonClick={() => {
          setConfirm(false);
          setConfirmDialog(false);
        }}
        positiveButtonClick={() => setConfirmDialog(false)}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <p>{`Are you want to change event time ${sourceInfo?.eventStartHour} to ${targetInfo?.eventStartHour} ? `}</p>
      </KenDialog>
      <KenPopover
        id={ids}
        open={open}
        anchorEl={anchorEl}
        // onMouseEnter={handlePopoverOpen}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          style: { width: 'auto', padding: '0px', minHeight: '60px' },
        }}
        hideNegativeButton={true}
        hidePositiveButton={true}
      >
        <div className={classes.popOverTitle}>Exam Details:</div>
        <div className={classes.popOverData}>Subject</div>
        <div className={classes.popOverData}>Faculty</div>
        <div className={classes.popOverData}>Venue</div>
      </KenPopover>
    </div>
    // </DragDropContext>
  );
};

export default CustomTimeline;
